import React, { memo } from 'react';
import { Header } from 'shared/components/Header';
import { useEffectOnMount } from 'shared/hooks/useEffectOnMount';
import { usePriceData } from 'shared/hooks/usePriceData';
import { LINK_PLAY, META, PRODUCT_NAME } from './constants';
import styles from './EnglishPet.module.scss';
import { Roof } from './components/Roof/Roof';
import { Demo } from './components/Demo/Demo';
import { Training } from './components/Training/Training';
import { Feedback } from './components/Feedback';
import { FAQ } from './components/Faq/Faq';
import { Footer } from './components/Footer/Footer';
import { Goals } from './components/Goals';

export const EnglishPet = memo(function EnglishPet() {
  const { price, paymentPath } = usePriceData(PRODUCT_NAME, 990);

  useEffectOnMount(() => {
    document.title = META.title;
  });

  return (
    <div>
      <Header type="gray" />
      <div className={styles.main}>
        <h1 className={styles.course_name}>Английский со зверятами</h1>
        <Roof link={paymentPath} price={price} />
        <Demo link={LINK_PLAY} />
        <Training />
        <Goals />
        <Feedback />
        <FAQ />
        <Footer link={paymentPath} price={price} />
      </div>
    </div>
  );
});
